import { getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import AddUser from "components/EmailAlerts/Add";
import ViewUserList from "components/EmailAlerts/View";
import useDebounce from "hooks/useDebounce";
import { useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Button, Input } from "styled";
import { TH } from "styled/table";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";

const EmailAlerts = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState("");
  const currentUser = useSelector((state) => state.user.currentUser);

  const debouncedValue = useDebounce(search, 1000);
  const { data: emailSchedulers, isLoading } = useQuery(
    ["email-scheduler", debouncedValue && debouncedValue],
    () => getAllData("/email-scheduler", { searchQuery: debouncedValue })
  );

  return (
    <div>
      <div className="mx-10 my-2">
        <div className="mt-8 flex justify-start gap-6 items-center flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>
          <Button
            className="!px-8 disabled:bg-gray-400"
            bgPrimary
            disabled={!checkPermission([permissions.manage_users], currentUser)}
            onClick={() => setShowAddmodel(true)}
          >
            Add
          </Button>
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Report</TH>
                      <TH scope="col">Frequency</TH>
                      <TH scope="col">Email</TH>
                      {/* <TH scope="col">Fleets</TH> */}
                      <TH scope="col">Created On</TH>
                      <TH scope="col">Actions</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {emailSchedulers?.data &&
                      emailSchedulers?.data.map((emailScheduler, index) => (
                        <ViewUserList
                          emailScheduler={emailScheduler}
                          key={emailScheduler._id}
                          index={index}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {showAddmodel && <AddUser handleClick={() => setShowAddmodel(false)} />}
    </div>
  );
};

export default EmailAlerts;
